/**
 * IM 服务地址配置
 * 根据环境变量(env)和系统类型(system)返回对应的 serviceUrl。
 *
 * env    可选值: dev | test | uat | pro
 * system 可选值: yms（云卖）| trs（泰瑞森）
 */

const SERVICE_URL_MAP = {
  yms: {
    dev: 'https://tms-dev.pvt.tongtool.com',
    test: 'https://tms-test.pvt.tongtool.com',
    uat: 'https://tms-uat.pvt.tongtool.com',
    pro: 'https://im.tongtool.com',
  },
  trs: {
    dev: 'https://tms-dev.pvt.tongtool.com',
    test: 'https://tms-test.pvt.tongtool.com',
    uat: 'https://tms1-uat.pvt.tongtool.com',
    pro: 'https://admin.tarazon.com',
  },
};

/**
 * 根据 window.location.origin 推断当前运行环境。
 * @param {string} [origin] 可选，默认取 window.location.origin。
 * @returns {'dev'|'test'|'uat'|'pro'}
 */
export const getEnvFromOrigin = (origin) => {
  origin = origin || window.location.origin;
  if (origin.includes('dev')) return 'dev';
  if (origin.includes('localhost')) return 'uat'; // 本地代理开发默认走测试环境
  if (origin.includes('test')) return 'test';
  if (origin.includes('uat')) return 'uat';
  return 'pro';
};

/**
 * 获取 IM serviceUrl 地址。
 * @param {string} env    环境标识，如 dev / test / uat / pro。
 * @param {string} system 系统标识，如 yms / trs。
 * @returns {string} 对应的 serviceUrl，未匹配时返回空字符串。
 */
export const getServiceUrl = (env, system) => {
  const systemConfig = SERVICE_URL_MAP[system];
  if (!systemConfig) return '';
  return systemConfig[env] || '';
};

export default SERVICE_URL_MAP;
